import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "next-i18next"
import {
  selectFavoritesState,
  getMyAccountListsWithLineItems,
  getProductBySlug,
  getSharedListProductData,
} from "@/store/features/favoritesSlice"
import {
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import Loader from "@/components/Loader"
import { getTranslations } from "@/components/MyFavorites/v1/MyList/localization"
import { NumericFormat } from "react-number-format"
import { useRouter } from "next/router"

import { getListTotalPrice } from "@/components/MyFavorites/v1/MyList/helper"
import {
  getUserPersona,
  removeMavenoidChat,
  addMavenoidChat,
} from "@/utils/helper"
import ListInventoryCheckModal from "@/components/MyFavorites/v1/MyList/ListInventoryCheckModal"
import { PRODUCT_BEST_SELLERS } from "@/constants/routes"
import {
  selectGenericState,
  showPreviewCart,
} from "@/store/features/genericSlice"
import styles from "@/components/ShareList/index.module.scss"
import Button from "@/components/core/Button/Button"
import wishIcon from "@/public/icons/wish.svg"
import backToTopIcon from "@/public/icons/back-top-arrow.svg"
import SaveToList from "@/components/SaveToList"
import ShareListRowItem from "@/components/ShareList/ShareListRowItem/ShareListRowItem"
import ListConfirmationModal from "@/components/ListConfirmationModal"
import CONSTANTS, { EXCEPTIONAL_SITENAME } from "@/constants/index"
import { dataLayerShareListPageEvents } from "@/components/MyFavorites/v1/MyList/analytics"
import { getStock } from "@/utils/cart"
import { shareaddToCart as addToCartHelper } from "@/components/sharedCart/shareCartHelper"
import ShareListModal from "@/components/ShareListModal"

const ShareList = props => {
  const {
    list = {},
    siteName = "",
    setSelectedList = () => {},
    deleteListSuccess = () => {},
  } = props

  const { access_token: accessToken, isAuth } = useSelector(selectAuthState)
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const router = useRouter()
  const {
    itemPrice,
    quantity,
    total,
    item,
    listTotal,
    browseMoreProducts,
    backToTop,
    addToCart,
    moreOptions,
    lessStock,
    outOfStock,
    availColorCTA,
    discontinued,
    requiredItemsToInstall,
    Remove,
  } = staticText
  const { globalConfig } = useSelector(selectGenericState)
  const {
    general = {
      swatchUrl: CONSTANTS?.COLOR_FILE_URL,
      siteName:
        EXCEPTIONAL_SITENAME.charAt(0).toUpperCase() +
        EXCEPTIONAL_SITENAME.slice(1),
    },
    internationalization: { language = "en", currencyCode = "" } = {},
    apiEndPointData: { map: { disableAddToCart = false } = {} } = {},
  } = globalConfig

  const { userListItemsSkus } = useSelector(selectFavoritesState)
  const [receivedSku, setReceivedSku] = useState("" || [])
  const [showAddToList, setShowAddToList] = useState(false)
  const [loginFavouriteCallback, setLoginFavouriteCallback] = useState(null)
  const [isShareAll, setIsShareAll] = useState(false)
  const [currentSingleProductDelete, setCurrentSingleProductDelete] = useState(
    []
  )
  const [openRemoveSingleProduct, setOpenRemoveSingleProduct] = useState(false)
  const [checkedItems, setCheckedItem] = useState([])
  const [productData, setProductData] = useState([])
  const [allProductsData, setAllProductsData] = useState([])
  const [baseData, setBaseData] = useState([])
  const [productQtyObj, setProductQtyObj] = useState({})
  const [openConforMationModal, setOpenConfirmationModal] = useState(false)
  const [deletList, setDeleteList] = useState(false)
  const [emptyList, setEmptyList] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [currentListVal, setCurrentListVal] = useState({})
  const [persona, setPersona] = useState("")
  const [listItemsPrice, setListItemsPrice] = useState({})
  const [showInventoryCheckModal, setShowInventoryCheckModal] = useState(false)
  const [lessStockProducts, setLessStockProducts] = useState([])
  const [outOfStockProducts, setOutOfStockProducts] = useState([])
  const [InStockProducts, setInStockProducts] = useState([])
  const [allItemsOutOfStock, setAllItemsOutOfStock] = useState(false)
  const [flewItemsLessStock, setFlewItemsLessStock] = useState(false)
  const [requiredInstallItems, setRequiredInstallItems] = useState([])
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  )
  const [showShareListModal, setShowShareListModal] = useState(false)
  const [showDownloadedMessage, setShowDownloadedMessage] = useState(false)
  const [sharedListName, setSharedListName] = useState("")
  const moreOptionsRef = useRef(null)
  const dispatch = useDispatch()
  const removeIcon = "/icons/removeIconList.svg"
  const shareIconImage = "/icons/shareimageIcon.svg"

  const getPresetConfigs = () => {
    const config = window?.localStorage?.getItem("caConfig-en") ?? "{}"
    const favoritesPercentConfigs =
      JSON.parse(config)?.presetConfigs?.favorites || "{}"
    return JSON.stringify(favoritesPercentConfigs)
  }

  useEffect(() => {
    if (typeof window === "undefined") return

    let rafId = null
    const handleResize = () => {
      // use rAF to avoid layout thrashing on rapid resizes
      if (rafId) cancelAnimationFrame(rafId)
      rafId = requestAnimationFrame(() => {
        setWindowWidth(window.innerWidth)
      })
    }

    window.addEventListener("resize", handleResize)
    // ensure initial value is accurate (in case of hydration differences)
    setWindowWidth(window.innerWidth)

    return () => {
      window.removeEventListener("resize", handleResize)
      if (rafId) cancelAnimationFrame(rafId)
    }
  }, [])

  useEffect(() => {
    const { products, ListName } = router?.query || {}
    if (!products) return
    try {
      const b64 = Array.isArray(products) ? products[0] : products

      // decode base64 (browser atob fallback to Buffer for safety)
      const decoded =
        typeof window !== "undefined" && typeof window.atob === "function"
          ? window.atob(b64)
          : Buffer.from(b64, "base64").toString("utf-8")
      const decodedListName =
        typeof window !== "undefined" && typeof window.atob === "function"
          ? window.atob(ListName)
          : Buffer.from(ListName, "base64").toString("utf-8")
      // try JSON parse first, otherwise treat as comma-separated string
      setSharedListName(decodedListName)
      let values = []
      try {
        const parsed = JSON.parse(decoded)
        if (Array.isArray(parsed)) values = parsed
        else if (typeof parsed === "string" || typeof parsed === "number")
          values = parsed
            .split(",")
            .map(s => s.trim())
            .filter(Boolean)
      } catch {
        values = decoded
          .split(",")
          .map(s => s.trim())
          .filter(Boolean)
      }
      setCheckedItem(values)
      dispatch(getSharedListProductData(values))
        .unwrap()
        .then(response => {
          const qtObject = {}
          const refinedResponse = []
          values?.forEach(sku => {
            qtObject[sku] = 1
            response.filter(productInfo => {
              if (
                productInfo["masterSKU_s"] === sku ||
                productInfo["variantList.sku_ss"]?.indexOf(sku) > -1
              ) {
                refinedResponse.push({ ...productInfo, masterSKU_s: sku })
              }
            })
          })

          setProductQtyObj(qtObject)
          setBaseData(refinedResponse)

          if (refinedResponse.length > 10) {
            const records = refinedResponse.slice(0, 10)
            setProductData(records)
            setAllProductsData(refinedResponse.slice(10))
          } else {
            setProductData(refinedResponse)
            setAllProductsData([])
          }
          setShowLoader(false)
        })
        .catch(() => {})
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Failed to decode products query param", err)
    }
  }, [])

  useEffect(() => {
    if (loginFavouriteCallback && isAuth) {
      dispatch(getMyAccountListsWithLineItems())
        .unwrap()
        .then(res => {
          window.loginFavouriteCallback = null
          setLoginFavouriteCallback(null)
          if (isShareAll) {
            setShowAddToList(true)
            setIsShareAll(false)
          } else {
            handleSaveToListFunctionality("", res[0][1])
          }
          getSkuPrice(baseData)
        })
    }
  }, [loginFavouriteCallback, isAuth])

  const handleAddItemAndRemoveItemFromList = (e, sku, shareAll) => {
    e.preventDefault()
    e.stopPropagation()
    setReceivedSku(sku)
    setIsShareAll(shareAll)
    if (isAuth && shareAll) {
      setShowAddToList(true)
      setIsShareAll(false)
      return
    }

    if (!isAuth) {
      window.loginFavouriteCallback = () => {
        setLoginFavouriteCallback(e)
      }
      dispatch(setAuthModalVisibility({ show: true }))
    } else {
      handleSaveToListFunctionality(sku)
    }
  }
  const handleSaveToListFunctionality = (sku = "", listSkuObject = {}) => {
    if (isShareAll) {
      setShowAddToList(true)
      setIsShareAll(false)
      return
    }
    const processingSku = sku || receivedSku
    const listObj = Object.keys(listSkuObject).length
      ? listSkuObject
      : userListItemsSkus

    if (listObj[processingSku]) {
      setCurrentSingleProductDelete([processingSku])
      setCurrentListVal(listObj[processingSku])
      setOpenRemoveSingleProduct(true)
    } else {
      setShowAddToList(true)
    }
  }

  const closeMultiItemsDeleteFromList = () => {
    setOpenRemoveSingleProduct(false)
    setCurrentSingleProductDelete([])
    setCurrentListVal({})
  }

  useEffect(() => {
    const node = moreOptionsRef.current
    if (!node) return
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          removeMavenoidChat()
        } else {
          addMavenoidChat()
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(node)
    return () => {
      observer.disconnect()
    }
  }, [checkedItems?.length])

  const handleInventoryCheckModalClose = () => {
    setShowInventoryCheckModal(false)
    setLessStockProducts([])
    setOutOfStockProducts([])
    setInStockProducts([])
    setAllItemsOutOfStock(false)
    setFlewItemsLessStock(false)
    setRequiredInstallItems([])
  }

  const handleAddToCart = async ctaLabel => {
    setShowLoader(true)
    const results = await getStock(checkedItems.join(","), true)
    const discontinutedSkusProducts = []
    const InStockProducts = []
    const lessStockProducts = []
    const outOfStockProducts = []
    const listItems = [...productData]

    productData.forEach((product, inventoryIndex) => {
      const inventoryObj = results?.results?.find(
        inv => inv.sku === product.masterSKU_s
      )

      if (!inventoryObj?.sku) {
        const product = listItems[inventoryIndex]
        product.inventory = 0
        product.stockStatus = "Out of Stock"
        outOfStockProducts.push(product)
        listItems[inventoryIndex] = product
        return
      }
      if (
        product?.["productRegionAllVariantDiscontinued_b"] ||
        product?.["ProductIsRetail_s"] === "true"
      ) {
        discontinutedSkusProducts.push(product)
      } else if (
        productQtyObj[inventoryObj.sku] < inventoryObj.availableQuantity ||
        productQtyObj[inventoryObj.sku] === inventoryObj.availableQuantity ||
        listItemsPrice[`${inventoryObj.sku}-RegionIsBackorderable`]
      ) {
        product["inventory"] = inventoryObj?.availableQuantity
        product["stockStatus"] = "In Stock"
        InStockProducts.push(product)
      } else if (
        productQtyObj[inventoryObj.sku] > inventoryObj?.availableQuantity &&
        inventoryObj.availableQuantity > 0
      ) {
        product["inventory"] = inventoryObj.availableQuantity
        product["stockStatus"] = "Less Stock"
        lessStockProducts.push(product)
      } else {
        product["inventory"] = 0
        product["stockStatus"] = "Out of Stock"
        outOfStockProducts.push(product)
      }
      listItems[inventoryIndex] = product
      return product
    })

    setInStockProducts(InStockProducts)
    setLessStockProducts(lessStockProducts)
    setOutOfStockProducts(outOfStockProducts)
    setProductData(listItems)
    const checkedItemsLength =
      listItems.length - discontinutedSkusProducts.length
    if (checkedItemsLength === InStockProducts.length) {
      const filterCheckedItems = checkedItems.filter(item => {
        const selectedProduct = productData.find(
          product => product.masterSKU_s === item
        )
        if (
          selectedProduct &&
          !selectedProduct["productRegionAllVariantDiscontinued_b"] &&
          selectedProduct["ProductIsRetail_s"] !== "true"
        ) {
          return true
        }
      })
      const payload = filterCheckedItems.map(item => {
        return {
          brand: "kohler",
          isBundleProduct: item?.startsWith("BNDL"),
          quantity: productQtyObj[item],
          sku: item,
          isBundle: listItemsPrice[`${item}-ComboSKU`] || false,
          backorder: listItemsPrice[`${item}-RegionIsBackorderable`] || false,
        }
      })
      setShowLoader(false)
      addToCartHelper([...payload], "", () => {
        dispatch(showPreviewCart())
        handleSingleItemsAddToCartDataLayerSuccessFailure({
          itemsObject: filterCheckedItems.map(item => ({
            productID: `K-${item}`,
            quantity: productQtyObj[item],
          })),
          eventStatus: "Success",
          eventMsg: "",
          handleSingleProduct: filterCheckedItems.length === 1,
          ctaLabel,
          productInfo:
            filterCheckedItems.length === 1
              ? productData.find(p => p.masterSKU_s === filterCheckedItems[0])
              : filterCheckedItems
                  .map(sku => productData.find(p => p.masterSKU_s === sku))
                  .filter(Boolean),
        })
      })
      handleInventoryCheckModalClose()
    } else if (checkedItemsLength === outOfStockProducts.length) {
      setShowLoader(false)
      setShowInventoryCheckModal(true)
      setAllItemsOutOfStock(true)
    } else if (
      checkedItemsLength ===
        lessStockProducts.length + InStockProducts.length ||
      checkedItemsLength ===
        lessStockProducts.length + outOfStockProducts.length ||
      checkedItemsLength ===
        lessStockProducts.length +
          outOfStockProducts.length +
          InStockProducts.length
    ) {
      setShowLoader(false)
      handleSingleItemsAddToCartDataLayerSuccessFailure({
        itemsObject: [
          ...lessStockProducts.map(item => ({
            productID: `K-${item.masterSKU_s}`,
            quantity: item?.inventory,
          })),
          ...outOfStockProducts.map(item => ({
            productID: `K-${item.masterSKU_s}`,
            quantity: 0,
          })),
        ],
        eventStatus: "failure",
        eventMsg:
          lessStockProducts.length && outOfStockProducts.length
            ? "low inventory, no inventory"
            : lessStockProducts.length
            ? "low inventory"
            : "no inventory",
        handleSingleProduct: false,
        ctaLabel,
        productInfo:
          checkedItems.length === 1
            ? productData.find(p => p.masterSKU_s === checkedItems[0])
            : checkedItems
                .map(sku => productData.find(p => p.masterSKU_s === sku))
                .filter(Boolean),
      })
      setShowInventoryCheckModal(true)
      setFlewItemsLessStock(true)
    } else {
      setShowLoader(false)
    }
  }

  const handleAvailableItemsToCart = ctaLabel => {
    setShowInventoryCheckModal(false)
    setShowLoader(false)
    const itemsObjForDataLayer = []
    const payloadInStock = InStockProducts.map(item => {
      itemsObjForDataLayer.push({
        productID: `K-${item.masterSKU_s}`,
        quantity: productQtyObj[item.masterSKU_s],
      })
      return {
        brand: "kohler",
        isBundleProduct: item.masterSKU_s?.startsWith("BNDL"),
        quantity: productQtyObj[item.masterSKU_s],
        sku: item.masterSKU_s,
        isBundle: listItemsPrice[`${item.masterSKU_s}-ComboSKU`] || false,
        backorder:
          listItemsPrice[`${item.masterSKU_s}-RegionIsBackorderable`] || false,
      }
    })
    const palloadLessStock = lessStockProducts.map(item => {
      itemsObjForDataLayer.push({
        productID: `K-${item.masterSKU_s}`,
        quantity: item?.inventory,
      })
      return {
        brand: "kohler",
        isBundleProduct: item.masterSKU_s?.startsWith("BNDL"),
        quantity: item?.inventory,
        sku: item.masterSKU_s,
        isBundle: listItemsPrice[`${item.masterSKU_s}-ComboSKU`] || false,
        backorder:
          listItemsPrice[`${item.masterSKU_s}-RegionIsBackorderable`] || false,
      }
    })
    const installItems = []
    if (requiredInstallItems?.length > 0) {
      requiredInstallItems.forEach(item => {
        installItems.push({
          brand: "kohler",
          quantity: 1,
          sku: item?.skuid,
        })
        itemsObjForDataLayer.push({
          productID: `K-${item?.skuid}`,
          quantity: 1,
        })
      })
    }
    setShowLoader(false)
    if (installItems?.length) {
      const actualAddedSkus = [
        ...payloadInStock,
        ...palloadLessStock,
        ...installItems,
      ].map(item => item.sku)
      addToCartHelper(
        [...payloadInStock, ...palloadLessStock, ...installItems],
        "",
        () => {
          dispatch(showPreviewCart())
          handleSingleItemsAddToCartDataLayerSuccessFailure({
            itemsObject: itemsObjForDataLayer,
            eventMsg: palloadLessStock.length > 0 ? "low inventory" : "",
            ctaLabel,
            productInfo: actualAddedSkus
              .map(sku => productData.find(p => p.masterSKU_s === sku))
              .filter(Boolean),
          })
        }
      )
    } else {
      const actualAddedSkus = [...payloadInStock, ...palloadLessStock].map(
        item => item.sku
      )
      addToCartHelper([...payloadInStock, ...palloadLessStock], "", () => {
        dispatch(showPreviewCart())
        handleSingleItemsAddToCartDataLayerSuccessFailure({
          itemsObject: itemsObjForDataLayer,
          eventMsg: palloadLessStock.length > 0 ? "low inventory" : "",
          ctaLabel,
          productInfo: actualAddedSkus
            .map(sku => productData.find(p => p.masterSKU_s === sku))
            .filter(Boolean),
        })
      })
    }

    handleInventoryCheckModalClose()
  }

  const handleBrowseMoreProducts = () => {
    dataLayerShareListPageEvents({
      name: sharedListName,
      persona: persona,
      actionType: "browse more products",
      productsCount: baseData.length,
      records: productData,
      quantityObject: productQtyObj,
      listItemsPrice,
      listTotalPrice: getListTotalPrice(
        baseData,
        productQtyObj,
        listItemsPrice
      ),
    })
    window.location.href = `${origin}/${language}${PRODUCT_BEST_SELLERS}`
  }

  const handleSingleItemToCartWithInstallItems = (items, sku) => {
    setShowLoader(true)
    getStock(sku, true)
      .then(inventory => {
        handleSingleItemToCartModal(inventory[0], sku, items)
      })
      .catch(() => {
        setShowLoader(false)
      })
  }
  const handleShareListAddToListAnalytics = () => {
    let actionType = "save to list"
    let records = []
    if (Array.isArray(receivedSku)) {
      actionType = "save all to list"
      records = [...productData]
    } else {
      records.push(
        productData.find(product => product.masterSKU_s === receivedSku)
      )
    }
    dataLayerShareListPageEvents({
      name: sharedListName,
      persona: persona,
      actionType: actionType,
      productsCount: baseData.length,
      eventType: "click",
      quantityObject: productQtyObj,
      records: records,
      listItemsPrice,
      listTotalPrice: getListTotalPrice(
        baseData,
        productQtyObj,
        listItemsPrice
      ),
    })
  }
  const handleSingleItemsAddToCartDataLayerSuccessFailure = data => {
    const {
      itemsObject = [],
      eventMsg = "",
      eventStatus = "Success",
      handleSingleProduct = false,
      ctaLabel = "",
      productInfo,
    } = data
    let safeProductInfo = Array.isArray(productInfo)
      ? productInfo
      : productInfo
      ? [productInfo]
      : []

    // If single product, send object not array for productInfo and records
    if (handleSingleProduct && safeProductInfo.length === 1) {
      safeProductInfo = safeProductInfo[0]
    }
    dataLayerShareListPageEvents({
      name: sharedListName,
      persona: persona,
      actionType: "add to cart",
      productsCount: baseData.length,
      eventStatus,
      eventType: "click",
      items: itemsObject,
      eventMsg,
      records:
        handleSingleProduct && safeProductInfo
          ? [safeProductInfo]
          : Array.isArray(safeProductInfo) && safeProductInfo.length
          ? safeProductInfo
          : [],
      quantityObject: productQtyObj,
      handleSingleProduct,
      ctaLabel,
      productInfo:
        handleSingleProduct && safeProductInfo
          ? safeProductInfo
          : safeProductInfo,
      listItemsPrice,
      listTotalPrice: getListTotalPrice(
        baseData,
        productQtyObj,
        listItemsPrice
      ),
    })
  }

  const handleSingleItemToCartModal = (
    inventory,
    sku,
    items = [],
    ctaLabel = ""
  ) => {
    if (
      productQtyObj[sku] < inventory?.availableQuantity ||
      productQtyObj[sku] === inventory?.availableQuantity ||
      listItemsPrice[`${sku}-RegionIsBackorderable`]
    ) {
      setShowLoader(false)
      const obj = {
        brand: "kohler",
        isBundleProduct: sku?.startsWith("BNDL"),
        quantity: productQtyObj[sku],
        sku: sku,
        isBundle: listItemsPrice[`${sku}-ComboSKU`] || false,
      }
      if (listItemsPrice[`${sku}-RegionIsBackorderable`]) {
        obj.backorder = true
      }
      const cartItems = [{ ...obj }]
      if (items?.length > 0) {
        items.forEach(item => {
          const itemObj = {
            brand: "kohler",
            quantity: 1,
            sku: item?.skuid,
          }
          cartItems.push(itemObj)
        })
      }

      addToCartHelper([...cartItems], "", () => {
        dispatch(showPreviewCart())
        const itemsObj = [
          { productID: `K-${sku}`, quantity: productQtyObj[sku] },
        ]
        if (items?.length > 0) {
          items.forEach(item => {
            const itemObj = {
              quantity: 1,
              productID: `k-${item?.skuid}`,
            }
            itemsObj.push(itemObj)
          })
        }
        handleSingleItemsAddToCartDataLayerSuccessFailure({
          itemsObject: itemsObj,
          handleSingleProduct: true,
          ctaLabel: staticText.addToCart,
          productInfo: [productData.find(p => p.masterSKU_s === sku)].filter(
            Boolean
          ),
        })
      })
    } else {
      items?.length > 0
        ? setRequiredInstallItems(items)
        : setRequiredInstallItems([])
      const lessStockProducts = []
      const outOfStockProducts = []
      let analyticsFired = false
      const inventoryCheckedProducts = productData.map(product => {
        if (product.masterSKU_s === sku) {
          if (
            productQtyObj[sku] > inventory.availableQuantity &&
            inventory.availableQuantity > 0
          ) {
            product.inventory = inventory.availableQuantity
            product.stockStatus = "Less Stock"
            setFlewItemsLessStock(true)
            lessStockProducts.push(product)
            if (!analyticsFired) {
              handleSingleItemsAddToCartDataLayerSuccessFailure({
                itemsObject: [
                  { productID: `K-${sku}`, quantity: productQtyObj[sku] },
                ],
                eventStatus: "failure",
                eventMsg: "low inventory",
                handleSingleProduct: true,
                ctaLabel: staticText.addToCart,
                productInfo: [
                  productData.find(p => p.masterSKU_s === sku),
                ].filter(Boolean),
                records: [productData.find(p => p.masterSKU_s === sku)].filter(
                  Boolean
                ),
              })
              analyticsFired = true
            }
            return product
          } else {
            product.inventory = 0
            product.stockStatus = "Out of Stock"
            outOfStockProducts.push(product)
            setAllItemsOutOfStock(true)
            if (!analyticsFired) {
              handleSingleItemsAddToCartDataLayerSuccessFailure({
                itemsObject: [
                  { productID: `K-${sku}`, quantity: productQtyObj[sku] },
                ],
                eventStatus: "failure",
                eventMsg: "no inventory",
                handleSingleProduct: true,
                ctaLabel: staticText.addToCart,
                productInfo: [
                  productData.find(p => p.masterSKU_s === sku),
                ].filter(Boolean),
                records: [productData.find(p => p.masterSKU_s === sku)].filter(
                  Boolean
                ),
              })
              analyticsFired = true
            }
            return product
          }
        } else {
          return product
        }
      })
      setLessStockProducts(lessStockProducts)
      setOutOfStockProducts(outOfStockProducts)
      setProductData(inventoryCheckedProducts)
      setShowLoader(false)
      setShowInventoryCheckModal(true)
    }
  }
  const handleSingleItemToCart = async (sku, ctaLabel) => {
    setShowLoader(true)
    getStock(sku, true)
      .then(inventory => {
        handleSingleItemToCartModal(inventory?.results[0], sku, [], ctaLabel)
      })
      .catch(() => {
        setShowLoader(false)
      })
  }

  const handleLoadMoreProducts = () => {
    const nextrecords = productData.length + 10
    if (nextrecords < baseData.length) {
      const records = baseData.slice(0, nextrecords)
      setProductData(records)
      setAllProductsData(baseData.slice(nextrecords))
    } else {
      const remainingRecords = baseData.slice(productData.length)
      const records = [...productData, ...remainingRecords]
      setProductData(records)
      setAllProductsData([])
    }
  }

  const getSkuPrice = async baseData => {
    let skuString = "("
    const listProductSkus = []
    baseData.forEach((obj, index) => {
      if (index === 0) {
        skuString += `"${obj["masterSKU_s"]}"`
      } else {
        skuString += `,"${obj["masterSKU_s"]}"`
      }
      listProductSkus.push(obj["masterSKU_s"])
    })
    skuString += ")"
    const payload = {
      listProductSkus,
      skuString,
      currencyCode,
      persona,
    }
    dispatch(getProductBySlug(payload))
      .unwrap()
      .then(res => {
        setListItemsPrice(res)
      })
      .catch(err => {
        console.error(err)
      })
  }

  useEffect(() => {
    if (baseData.length) getSkuPrice(baseData)
  }, [baseData])

  useEffect(() => {
    if (accessToken) {
      setPersona(getUserPersona())
    }
  }, [accessToken])

  useEffect(() => {
    if (baseData.length > 10) {
      setProductData(baseData.slice(0, 10))
      setAllProductsData(baseData.slice(10))
    } else {
      setProductData(baseData)
    }
  }, [baseData])

  const qtyChange = async (qty, product) => {
    setShowLoader(true)
    const sku = product["masterSKU_s"]
    const obj = { ...productQtyObj }
    obj[sku] = qty
    setProductQtyObj(obj)
    setShowLoader(false)
  }

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const closeModalWithOutDelete = () => {
    setOpenConfirmationModal(false)
    setDeleteList(false)
    setEmptyList(false)
  }

  const closeConfirmationModal = () => {
    setOpenConfirmationModal(false)
    setDeleteList(false)
    setEmptyList(false)
    deleteListSuccess()
  }

  const handleShareListModalClose = () => {
    setShowShareListModal(false)
    setShowDownloadedMessage(false)
  }

  return (
    <>
      <div
        className={styles.ShareListWrapper}
        data-more={checkedItems?.length ? "show-more" : "hide-more"}
      >
        {productData?.length > 0 ? (
          <div className="list-title">
            <div className="title-buttons-Row">
              <div className="share-list-title">
                {t("kf.share.list.shared.items", {
                  number: productData?.length,
                })}
              </div>
              <div
                className="buttons-Row"
                data-CA-Action-Btn={disableAddToCart ? "CATBTN" : ""}
              >
                <div
                  className={disableAddToCart ? "button-one-ca" : "button-one"}
                >
                  <Button
                    role="button"
                    size="small"
                    flexible
                    type="ghost"
                    className="button"
                    iconClass="wish-icon"
                    icon={wishIcon?.src}
                    iconProps={{ width: "15", height: "14", alt: moreOptions }}
                    label={t("kf.share.list.shared.save.all.to.list")}
                    onClick={e => {
                      handleAddItemAndRemoveItemFromList(e, checkedItems, true)
                    }}
                  />
                </div>
                {!disableAddToCart ? (
                  <div className="button-two">
                    <Button
                      role="button"
                      size="small"
                      flexible
                      type="ghost"
                      className="button cart-button"
                      onClick={handleAddToCart}
                      label={t("kf.share.list.shared.add.all.to.cart")}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
        {productData?.length > 0 ? (
          <>
            <div className="list-landing">
              <div className="list-grid">
                <div
                  className={`row cart-items__th no-gutters ${
                    productData?.length > 0
                      ? "cart-table-header-list display-none"
                      : ""
                  }`}
                >
                  <div
                    className="col-4 d-none d-sm-block text-left cart-items__td px-0 col-md-6 display-none"
                    aria-hidden="true"
                  >
                    {item}
                  </div>
                  <div className="col-12 col-sm-6 col-md-6">
                    <div className="row mx-0 px-0">
                      <div
                        className="col-4 d-none d-sm-block  cart-items__td cart-td-unit-price display-none"
                        aria-hidden="true"
                      >
                        {itemPrice}
                      </div>
                      <div
                        className="col-4 d-none d-sm-block text-center cart-items__td px-0 display-none"
                        aria-hidden="true"
                      >
                        {quantity}
                      </div>

                      <div
                        className="col-4 d-none d-sm-block text-right cart-items__td px-0 display-none"
                        aria-hidden="true"
                      >
                        {total}
                      </div>
                    </div>
                  </div>
                </div>
                {productData?.length > 0
                  ? productData.map((product, index) => {
                      return (
                        <ShareListRowItem
                          key={index}
                          presetConfigs={getPresetConfigs()}
                          product={product}
                          general={general}
                          persona={persona}
                          siteName={siteName}
                          productQtyObj={productQtyObj}
                          checkedItems={checkedItems}
                          disableAddToCart={disableAddToCart}
                          list={list[0]}
                          addToCart={addToCart}
                          listItemsPrice={listItemsPrice}
                          qtyChange={(qty, product) => {
                            qtyChange(qty, product)
                          }}
                          lessStock={lessStock}
                          outOfStock={outOfStock}
                          handleSingleItemToCart={handleSingleItemToCart}
                          handleSingleItemToCartWithInstallItems={
                            handleSingleItemToCartWithInstallItems
                          }
                          availColorCTA={availColorCTA}
                          discontinuedText={discontinued}
                          requiredItemsToInstall={requiredItemsToInstall}
                          staticText={staticText}
                          removeIcon={removeIcon}
                          Remove={Remove}
                          listInfo={list}
                          userListItemsSkus={userListItemsSkus}
                          handleAddItemAndRemoveItemFromList={
                            handleAddItemAndRemoveItemFromList
                          }
                          shareIcon={shareIconImage}
                        />
                      )
                    })
                  : null}
              </div>
              <div
                className="list-footer"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                {windowWidth > 812 ? (
                  <div
                    className="list-browse-more-text"
                    onClick={handleBrowseMoreProducts}
                  >
                    {browseMoreProducts}
                  </div>
                ) : null}

                <div className="list-total-text display-none">
                  {listTotal}:
                  <span style={{ paddingLeft: "20px" }}>
                    <NumericFormat
                      value={getListTotalPrice(
                        baseData,
                        productQtyObj,
                        listItemsPrice
                      )}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={disableAddToCart ? "CAD $" : "$"}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </span>
                </div>
              </div>
              {allProductsData.length ? (
                <div className="load-more-button">
                  <Button
                    label={staticText?.loadMore}
                    role="button"
                    size="small"
                    flexible
                    type="ghost"
                    onClick={handleLoadMoreProducts}
                  />
                </div>
              ) : null}
              <div
                className="list-back-to-top"
                show-more={checkedItems.length ? "showMore" : "hideMore"}
              >
                <button
                  role="link"
                  className={"go-back-button"}
                  onClick={handleBackToTop}
                >
                  <span className={"go-back-text"}>{backToTop}</span>
                  <img
                    className={"go-back-image"}
                    aria-hidden="true"
                    src={backToTopIcon?.src}
                    alt={backToTop}
                  />
                </button>
              </div>
            </div>
          </>
        ) : null}

        {openConforMationModal ? (
          <ListConfirmationModal
            list={currentListVal}
            openConforMationModal={openConforMationModal}
            noLineItems={emptyList}
            deletefromListDetails={deletList}
            closeConformationModal={closeConfirmationModal}
            setSelectedList={setSelectedList}
            closeModalWithOutDelete={closeModalWithOutDelete}
          />
        ) : null}
        {openRemoveSingleProduct ? (
          <ListConfirmationModal
            list={currentListVal}
            openConforMationModal={openRemoveSingleProduct}
            selectedItems={currentSingleProductDelete}
            deleteFromList={true}
            handleSuccessCallBack={closeMultiItemsDeleteFromList}
            closeConformationModal={() => {
              setOpenRemoveSingleProduct(false)
            }}
          />
        ) : null}
        {showLoader ? <Loader /> : null}
        {showAddToList ? (
          <SaveToList
            productSku={receivedSku}
            showListSaveAndCreate={showAddToList}
            fromShareListPage={true}
            listSaveAndCreateClose={() => {
              setShowAddToList(false)
            }}
            handleShareListAddToListAnalytics={
              handleShareListAddToListAnalytics
            }
          />
        ) : null}
        {showInventoryCheckModal ? (
          <ListInventoryCheckModal
            closeInventoryCheckModal={handleInventoryCheckModalClose}
            general={general}
            presetConfigs={getPresetConfigs()}
            productData={[...lessStockProducts, ...outOfStockProducts]}
            siteName={general?.siteName ?? ""}
            productQtyObj={productQtyObj}
            allItemsOutOfStock={allItemsOutOfStock}
            flewItemsLessStock={flewItemsLessStock}
            staticText={staticText}
            handleAvailableItemsToCart={() =>
              handleAvailableItemsToCart(staticText.addAvailableItemsToCart)
            }
          />
        ) : null}

        {showShareListModal ? (
          <ShareListModal
            showShareListModal={showShareListModal}
            showDownloadedMessage={showDownloadedMessage}
            onClose={() => {
              handleShareListModalClose()
            }}
          />
        ) : null}
      </div>
      <div className={styles.ShareListMoreOptionsWrapper} ref={moreOptionsRef}>
        <Button
          role="button"
          size="small"
          flexible
          type="ghost"
          className="more-options-btns"
          iconClass="wish-icon"
          icon={wishIcon?.src}
          iconProps={{ width: "15", height: "14", alt: moreOptions }}
          label={t("kf.share.list.shared.save.all.to.list")}
          onClick={e => {
            handleAddItemAndRemoveItemFromList(e, checkedItems, true)
          }}
        />

        {!disableAddToCart ? (
          <Button
            role="button"
            size="small"
            flexible
            type="ghost"
            className="more-options-btns cart-button"
            onClick={handleAddToCart}
            label={t("kf.share.list.shared.add.all.to.cart")}
          />
        ) : null}
      </div>
    </>
  )
}

export default ShareList
